import React from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { Modal } from 'msp-components'

const messages = defineMessages({
  successTitle: {
    id: 'cancellation_form.success.title',
    defaultMessage: 'Your cancellation has been submitted'
  },
  successDescription: {
    id: 'cancellation_form.success.description',
    defaultMessage:
      'We have received your withdrawal. You will immediately receive confirmation of receipt by email.'
  }
})

type SuccessModalProps = {
  isOpen: boolean
  onClose: () => void
  successMessage?: string
}

const SuccessModal = ({
  isOpen,
  onClose,
  successMessage
}: SuccessModalProps) => {
  const { formatMessage } = useIntl()
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCloseButtonClick={onClose}
      overlay
      closeOnOverlayClick
      blockScroll
      style='bg-accentGreen text-white fill-white'
      modalBody={
        <>
          <h2 className='font-Lora text-24 mb-4 font-bold'>
            {formatMessage(messages.successTitle)}
          </h2>
          <p className='font-Roboto text-16'>
            {successMessage || formatMessage(messages.successDescription)}
          </p>
        </>
      }
    />
  )
}

export default SuccessModal
